import { inject, Injectable, Signal } from '@angular/core';
import { IS_B2B } from '@lentau/profile/organizations/legal-entity/shared/tokens/is-b2b-profile.token';
import { UserFacade } from '@lentau/profile/store/user/user.facade';

@Injectable({
  providedIn: 'root',
})
export class KppFactory {
  private isB2B: Signal<boolean> = inject(IS_B2B);
  private userFacade: UserFacade = inject(UserFacade);

  public get(): string {
    if (this.isB2B()) {
      return this.userFacade.legalEntityId() || '';
    }

    return this.userFacade.buyerId()?.toString() || '';
  }
}
